/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Slimy_Bald_Cod_StirInputs */

const fr_slimy_bald_cod_stir = /** @type {(inputs: Slimy_Bald_Cod_StirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifiez la catégorie ${i?.title}. Ajustez le titre, la description et les paramètres de visibilité pour mieux organiser vos programmes.`)
};

/**

* @param {Slimy_Bald_Cod_StirInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const slimy_bald_cod_stir = /** @type {((inputs: Slimy_Bald_Cod_StirInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slimy_Bald_Cod_StirInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_slimy_bald_cod_stir(inputs)
});